import forumNav from '@/forumcomponents/forumNav'
import miniNav from '@/forumViews/about/miniNav/miniNav'
export const about = [
    {
      path: '/forum/about',
      name: '_forumHome',
      component: forumNav,
      children: [{
        path: '/forum/about',
        redirect: '/forum/about/intro',
        component: miniNav,
        children:[{
            path: '/forum/about/intro',//简介,
            name: 'forumIntro',
            component:()=>import('@/forumViews/about/firstList/intro')
        },{
            path: '/forum/about/vision',
            name: 'forumVision', //愿景使命
            component: () => 
            import ('@/forumViews/about/firstList/vision')
        },
        {
            path: '/forum/about/committee',
            name: 'forumCommittee', //科学委员会
            component: () => 
            import ('@/forumViews/about/firstList/committee')
        },
        {
            path: '/forum/about/council',
            name: 'forumCouncil',//理事会
            component: () => 
            import ('@/forumViews/about/firstList/council')
        },{
            path: '/forum/about/institutional',
            name: 'forumInstitutional', //机构理事
            component: () => 
            import ('@/forumViews/about//firstList/institutional')
        },{
            path: '/forum/about/YouthCouncil',
            name: 'forumYouthCouncil', //青年理事
            component: () => 
            import ('@/forumViews/about/firstList/youthCouncil')
        },{
            path: '/forum/about/YOSIA',
            name: 'forumYOSIA', //青创联盟
            component: () => 
            import ('@/forumViews/about/firstList/yosia')
        },{
            path: '/forum/about/executive',
            name: 'forumExecutive', //轮值主席
            component: () => 
            import ('@/forumViews/about/executive')
        },{
            path: '/forum/about/character',//人物信息/character/info
            component: () => 
            import ('@/forumViews/about/character')
        },
        {
            path: '/forum/about/list',
            name: 'forumList', //轮值主席
            component: () => 
            import ('@/forumViews/about/list')
        },
    ]
    }]
}]